import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "14",
  height: "14",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#E14225",
      d: "M7 0a6.998 6.998 0 0 1 4.992 11.908A7.001 7.001 0 0 1 .004 7.224L0 6.997l.003-.196A7 7 0 0 1 7 0m0 6.298h-.7l-.082.004a.7.7 0 0 0 0 1.39l.082.005v2.1l.005.081a.7.7 0 0 0 .613.613l.082.005h.7l.082-.005a.7.7 0 0 0 .613-.613l.005-.082-.005-.082a.7.7 0 0 0-.535-.6l-.078-.013-.082-.005V6.997l-.005-.082a.7.7 0 0 0-.613-.613zm.007-2.1-.089.005a.7.7 0 0 0 0 1.39L7 5.598l.089-.005a.7.7 0 0 0 0-1.39z"
    }, null, -1)
  ]))]))
}
export default { render: render }